import { render, staticRenderFns } from "./ViewOpinion.vue?vue&type=template&id=a8c37dd4&scoped=true"
import script from "./ViewOpinion.vue?vue&type=script&lang=js"
export * from "./ViewOpinion.vue?vue&type=script&lang=js"
import style0 from "./ViewOpinion.vue?vue&type=style&index=0&id=a8c37dd4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8c37dd4",
  null
  
)

export default component.exports